/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upcomingevents1Inputs */

const en_upcomingevents1 = /** @type {(inputs: Upcomingevents1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upcoming Events`)
};

const de_upcomingevents1 = /** @type {(inputs: Upcomingevents1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommende Events`)
};

/**
* | output |
* | --- |
* | "Upcoming Events" |
*
* @param {Upcomingevents1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const upcomingevents1 = /** @type {((inputs?: Upcomingevents1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upcomingevents1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upcomingevents1(inputs)
	return de_upcomingevents1(inputs)
});
export { upcomingevents1 as "upcomingEvents" }